<template>
  <div>
    <nav class="sidebar-nav sidebar_nav" aria-label="main-menu">
      <div class="sidebar_scroll" v-if="showMenu">
        <ul class="nav">
          <li
            :class="{
              'nav-item': true,
              'nav-dropdown': item.children && item.children.length > 0
            }"
            v-for="(item, index) in listNav"
            :key="index"
            @mouseenter="handleDropdownMouseEnter($event)"
            @click="goToPage(item.children && item.children.length > 0 ? '' : item.url, item)"
            :title="
              (item.children && item.children.length > 0) || minisizeMenu === false
                ? ''
                : item.name
            "
            disabled="disabled"
          >
            <a
              :href="item.url"
              @click="clickATag"
              v-if="!item.children || item.children.length == 0"
              :class="{
                'nav-link': true,
                'parent': true,
                'active': checkActiveClass(item, item)
              }"
            >
              <i :class="`nav-icon ${item.icon}`"></i>
              <span class="name-menu">{{ item.name }}</span>
            </a>
            <p
              v-if="item.children && item.children.length > 0"
              class="nav-link parent nav-dropdown-toggle"
            >
              <i :class="`nav-icon ${item.icon}`"></i>
              <i
                class="isax-arrow-up-2 miniNav-dropdown-toggle"
              >
              </i>
              <span class="name-menu">{{ item.name }}</span>
            </p>

            <ul
              v-if="item.children && item.children.length > 0"
              :class="['nav-dropdown-items', item.dropdownClass]"
            >
              <li
                v-for="(e, i) in item.children"
                :key="i"
                class="nav-item"
                @click="goToPage(e.url, item.children[i])"
              >
                <!-- :class="path == e.url ? 'nav-link active' : 'nav-link'" -->
                <a
                  :href="e.url"
                  @click="clickATag"
                  :class="{
                    'nav-link': true,
                    'active': checkActiveClass(item.children[i])
                  }"
                >
                  <i :class="`nav-icon ${e.icon}`"></i>
                  <span>{{ e.name }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
    <nav class="sidebar-nav sidebar_nav" aria-label="sub-menu">
      <div class="sidebar_scroll" v-if="showMenuPreventive">
        <ul class="nav">
          <li
            :class="
              item.children && item.children.length > 0
                ? 'nav-item nav-dropdown'
                : 'nav-item'
            "
            v-for="(item, index) in listNav"
            :key="index"
            @mouseenter="handleDropdownMouseEnter($event)"
            @click="goToPage(item.children && item.children.length > 0 ? '' : item.url)"
            :title="
              (item.children && item.children.length > 0) || minisizeMenu === false
                ? ''
                : item.name
            "
            disabled="disabled"
          >
            <a
              :href="item.url"
              @click="clickATag"
              v-if="!item.children || item.children.length == 0"
              :class="{
                'nav-link': true,
                'active': checkActiveClass(item)
              }"
            >
              <i :class="`nav-icon ${item.icon}`"></i>
              <span class="name-menu">{{ item.name }}</span>
            </a>
            <p
              v-if="item.children && item.children.length > 0"
              class="nav-link nav-dropdown-toggle"
            >
              <i :class="`nav-icon ${item.icon}`"></i>
              <i
                class="isax-arrow-up-2 miniNav-dropdown-toggle"
              >
              </i>
              <span class="name-menu">{{ item.name }}</span>
            </p>

            <ul
              v-if="item.children && item.children.length > 0"
              :class="['nav-dropdown-items', item.dropdownClass]"
            >
              <li
                v-for="(e, i) in item.children"
                :key="i"
                class="nav-item"
                @click="goToPage(e.url, item.children[i])"
              >
                <a
                  :href="e.url"
                  @click="clickATag"
                  :class="{
                    'nav-link': true,
                    'active': checkActiveClass(item.children[i])
                  }"
                >
                  <i :class="`nav-icon ${e.icon}`"></i>
                  <span>{{ e.name }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import EventBus from "@/service/EventBus"
import MethodService from "../service/MethodService"
export default {
  props: {
    listNav: {
      type: Array,
      default: () => {[]},
    },
    minisizeMenu: {
      type: Boolean,
      default: false,
    },
    isSystemAdmin: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      path: "",
      collection: "",
      showMenu: true,
      showMenuPreventive: false,
      currentUser: MethodService.getCurrentUser(),
    }
  },
  methods: {
    clickATag(e) {
      e.preventDefault()
    },
    setSystemSettingsDropdownMaxHeight(dropdown) {
      if (!dropdown) return;
      const viewportBottomSpacing = 20;
      const viewportTopSpacing = 20;
      const preferredMaxHeight = 500;

      dropdown.style.removeProperty("--system-settings-dropdown-top");
      dropdown.style.removeProperty("--system-settings-dropdown-max-height");

      const rect = dropdown.getBoundingClientRect();
      const viewportMaxHeight = Math.max(0, window.innerHeight - viewportTopSpacing - viewportBottomSpacing);
      const targetHeight = Math.min(
        dropdown.scrollHeight || rect.height || preferredMaxHeight,
        preferredMaxHeight,
        viewportMaxHeight
      );
      const top = Math.max(
        viewportTopSpacing,
        Math.min(rect.top, window.innerHeight - targetHeight - viewportBottomSpacing)
      );
      const maxHeight = Math.max(0, window.innerHeight - top - viewportBottomSpacing);

      dropdown.style.setProperty("--system-settings-dropdown-top", `${top}px`);
      dropdown.style.setProperty("--system-settings-dropdown-max-height", `${maxHeight}px`);
    },
    handleDropdownMouseEnter(event) {
      const dropdown = event.currentTarget.querySelector(".nav-dropdown-items--system-settings");
      if (!dropdown) return;

      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          this.setSystemSettingsDropdownMaxHeight(dropdown);
        });
      });
    },
    updateOpenSystemSettingsDropdown() {
      const dropdown = this.$el.querySelector(".nav-dropdown:hover .nav-dropdown-items--system-settings");
      this.setSystemSettingsDropdownMaxHeight(dropdown);
    },
    goToPage(url, item) {
      if (url == "") return
      if (url == this.$router.currentRoute.path) return
      if (item && item.activeurl && item.activeurl.includes(this.$router.currentRoute.path)) return
      this.$router.push({
        path: url,
      }).catch((err) => {})
      // this.checkRoute()
    },
    checkRoute() {
      this.path = this.$router.currentRoute.path
      this.collection = this.$router.currentRoute.meta.collection
    },
    checkActiveClass(item) {
      if (item.activeurl) {
        return item.activeurl.includes(this.$router.currentRoute.path) ? true : false
      }
      return this.$router.currentRoute.path == item.url ? true : false
    }
  },
  created() {
    this.checkRoute()
    EventBus.$off("ChangeRouteSubNav")
    EventBus.$on("ChangeRouteSubNav", () => {
      this.showMenu = false
      this.showMenuPreventive = true
      setTimeout(() => {
        this.checkRoute()
        this.showMenu = true
        this.showMenuPreventive = false
      }, 500)
    });
  },
  mounted() {
    window.addEventListener("resize", this.updateOpenSystemSettingsDropdown);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateOpenSystemSettingsDropdown);
  },
};
</script>

<style lang="scss" scoped>
.name-menu {
  font-family: UTM Avo !important;
  margin-left: 15px;
}
.nav-item:hover {
  cursor: pointer;
}
.miniNav-dropdown-toggle {
  position: absolute;
  font-size: 14px;
  font-weight: 700;
  right: 7px;
  top: 18px;
  transform: rotate(0);
}
.sidebar .nav-dropdown-toggle::before {
  width: 13px;
  height: 13px;
  margin-top: -6px;
  background-image: url("/img/arrow.png") !important;
}
.nav-item.nav-dropdown:hover {
  .nav-dropdown-toggle::before {
    transform: rotate(180deg);
  }
  .miniNav-dropdown-toggle {
    transform: rotate(180deg);
  }
}
</style>
